declare global {
  const tarteaucitron: any;
}

import { KbCookies } from "./kb-cookies";

/**
 * This class is related the the tarteaucitron cookie bar, and checks if use clicks on link or buttons
 * which trigger implict acceptation for third party cookies
 */
export class KbCookiebar {
  public static cookieName = "cookie_manager";

  constructor() {
    
  }

}
